import React from 'react';
import './Footer.css';
import logoMab from '../../uploads/logo/RyQ.png'; // Logo principal
import logoCse from '../../uploads/creditos/CSE.png'; // Logo de créditos

const Footer = () => {
  return (
    <footer className="site-footer">
      {/* --- SECCIÓN SUPERIOR --- */}
      <div className="footer-top">
        <div className="footer-container">
          {/* Columna del Logo y Redes Sociales */}
          <div className="footer-column logo-column">
            <img src={logoMab} alt="Logo R&Q Ingeniería" className="footer-logo" />
            <div className="social-links">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">in /ryq_ingenieria</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">@ryqingenieria</a>
            </div>
          </div>

          {/* Columna de Información: R&Q Colombia */}
          <div className="footer-column info-column">
            <h4>R&Q Colombia</h4>
            <p>
              Carrera 13 #37-37 <br />
              Oficina 801 <br />
              Edificio Cavipetrol
            </p>
          </div>
        </div>
      </div>
      
      {/* --- SECCIÓN INFERIOR DE CRÉDITOS --- */}
      <div className="footer-credits">
        <div className="credits-container">
          <h5>Desarrollo y Soporte Tecnológico</h5>
          <div className="credits-wrapper">
            {/* Bloque de Gestión y Dirección (Sin cambios) */}
            <div className="credit-block">
              <img src={logoCse} alt="Logo CSE" className="credit-logo" />
              <div className="credit-text">
                <h6>Gestión y Dirección</h6>
                <p>CSE - Ing. Oscar Guerrero</p>
                <a href="mailto:gerencia@csesas.com">gerencia@csesas.com</a>
                <a href="https://www.csesas.com/" target="_blank" rel="noopener noreferrer">www.csesas.com</a>
              </div>
            </div>

            {/* Bloque del Equipo de Desarrollo (MEJORADO) */}
            <div className="credit-block">
              <div className="credit-text">
                <h6>Equipo de Desarrollo</h6>
                <p>RamSoft</p>
                <div className="developer-names">
                  <span>Ing. Sebastián Zapata</span>
                  <span>Ing. Brayan Ramírez</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;